import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import {RiMailSendLine} from 'react-icons/ri';

let SendEmailButton = (props) => {
    return (
        <IconButton 
            aria-label="Download"
            onClick={() => props.onClick()}
        >
            <RiMailSendLine />
        </IconButton>
    );
}

export default SendEmailButton;